
import { Options, prop, Vue } from "vue-class-component";
import PriceTypeForm from "./price-type-form.vue";
import { ModalMessageEntities, OptionsClass } from "@/domain/entities/MainApp";
import { AddRenewRatesClientManagementApiRequestV2 } from "@/data/payload/api/ClientManagementApiRequest";
import { formatDateNormal } from "@/app/infrastructures/misc/Utils";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import moment from "moment";

class Props {
  modelValue = prop<any>({
    required: false,
    type: Object
  });
  clientName = prop<string>({
    type: String,
    default: ""
  });
  detailClient = prop<any>({
    type: Object,
    default: ""
  });
  isEdit = prop<any>({
    required: false,
    type: Object
  });
}

@Options({
  emits: ["update:modelValue"],
  components: {
    PriceTypeForm
  }
})
class PopupRenewRate extends Vue.with(Props) {
  form = {
    isCustomRate: this.isEdit ? this.mappingPriceType : "retail",
    isInsurance:
      this.isEdit &&
      this.detailClient?.clientCurrentRate?.clientRateInsuranceType
        ? true
        : false,
    insurance:
      this.isEdit &&
      this.detailClient?.clientCurrentRate?.clientRateInsuranceType
        ? this.detailClient?.clientCurrentRate?.clientRateInsuranceType
        : "",
    customRates:
      this.isEdit &&
      this.detailClient?.clientCurrentRate?.clientRateInsuranceType ===
        "custom-rates" || this.detailClient?.clientCurrentRate?.clientRateInsuranceType === "custom"
        ? String(this.detailClient?.clientCurrentRate
            ?.clientRateInsuranceValuePercentage).split('.')[1] || ''
        : "",
    priceRateStartDate:
      this.isEdit &&
      this.detailClient?.clientCurrentRate.clientRateversionStartDate
        ? this.detailClient?.clientCurrentRate.clientRateversionStartDate
        : "",
    priceRateEndDate:
      this.isEdit &&
      this.detailClient?.clientCurrentRate.clientRateVersionEndDate
        ? this.detailClient?.clientCurrentRate.clientRateVersionEndDate
        : "",
    priceRateExpired: this.isDateTimeEnabled ? this.today : this.tomorrow,
    originCities:
      this.isEdit &&
      this.detailClient.clientCurrentRate.clientRateVersionCustom3lc
        ? (() => {
            const text = this.detailClient.clientCurrentRate.clientRateVersionCustom3lc
            const [valuePart] = text.split(" - ")
            return [
              {
                name: text,
                value: valuePart.trim()
              }
            ] as OptionsClass[]
          })()
        : ([] as OptionsClass[]),
    discount:
      this.isEdit && this.detailClient?.clientCurrentRate?.discountProductTypes?.length
        ? this.detailClient.clientCurrentRate.discountProductTypes.map(
            (d: any) => ({
              discount: String(d.discount),
              product: { name: d.productType }
            })
          )
        : [
            {
              discount: this.detailClient?.clientCurrentRate
                ?.clientDiscountBaseRate,
              product: { name: "SEMUA" }
            }
          ],
    versionName:
      this.isEdit && this.detailClient.clientCurrentRate.clientVersionCustomRate
        ? this.detailClient.clientCurrentRate.clientVersionCustomRate
        : "",
    archiveFile: "" as any,
    retailBasedDistrict: !!this.detailClient.clientCurrentRate.clientRatePriceType
      ?.toLowerCase()
      .match(/retail/),
    versionBasic: this.isEdit
      ? this.detailClient.clientCurrentRate.clientVersionBaseRate
      : "",
    rateVersionId: "",
    detailData: this.detailClient,
    useClientDiscountConfig: true
  };

  created() {
    this.form.useClientDiscountConfig =
      this.detailClient?.clientCurrentRate?.useClientDiscountConfig ?? true;
  }

  error = {
    isCustomRate: false,
    isInsurance: false,
    insurance: false,
    customRates: false,
    priceRateStartDate: false,
    priceRateEndDate: false,
    priceRateExpired: false,
    originCities: false,
    discount: false,
    versionName: false,
    archiveFile: false,
    retailBasedDistrict: false,
    versionBasic: false
  };

  get isDateTimeEnabled() {
    return FlagsPermissionClient.permission_period_date_time.isEnabled()
  }

  get customPriceOption() {
    const mapped = this.mappingPriceType;
    return [
      {
        disabled: ["khusus", "kombinasi"].includes(mapped),
        label: this.$t("clientManagement.infoPriceClient.priceRetail").toString(),
        description: this.$t("clientManagement.infoPriceClient.priceRetailDescription").toString(),
        value: "retail"
      },
      {
        disabled: ["khusus", "kombinasi"].includes(mapped),
        label: this.$t("clientManagement.infoPriceClient.priceNormal").toString(),
        description: this.$t("clientManagement.infoPriceClient.priceNormalDescription").toString(),
        value: "normal"
      },
      {
        disabled: ["kombinasi"].includes(mapped),
        label: this.$t("clientManagement.infoPriceClient.priceSpecial").toString(),
        description: this.$t("clientManagement.infoPriceClient.priceSpecialDescription").toString(),
        value: "khusus"
      },
      {
        disabled: ["khusus"].includes(mapped),
        label: this.$t("clientManagement.infoPriceClient.priceCombination").toString(),
        description: this.$t("clientManagement.infoPriceClient.priceCombinationDescription").toString(),
        value: "kombinasi"
      }
    ];
  }

  confirnation = false;

  get mappingPriceType() {
    const priceType = this.detailClient?.clientCurrentRate?.clientRatePriceType;
    if (
      priceType === "custom_client" ||
      priceType === "custom_client_retail_district"
    ) {
      return "khusus";
    } else if (
      priceType === "combination" ||
      priceType === "combination_custom_3lc" ||
      priceType === "combination_retail_district" ||
      priceType === "combination_custom_3lc_retail_district"
    ) {
      return "kombinasi";
    }
    return this.detailClient?.clientCurrentRate?.clientRatePriceType;
  }
  onShowHidePopup() {
    this.$emit("update:modelValue", !this.modelValue);
  }



  get insurancePercentage() {
    return this.form.isInsurance &&
      (this.form.insurance === "custom-rates" ||
        this.form.insurance === "custom")
      ? Number(Number("0." + this.form.customRates).toFixed(2))
      : 0;
  }

  get id() {
    return this.$route.params.id;
  }

  get priceType() {
    let priceTypeVal = "";
    const lowerCustomRate = this.form.isCustomRate.toLowerCase();
    if (lowerCustomRate === "retail") priceTypeVal = "retail";
    if (
      lowerCustomRate === "normal" &&
      this.form.originCities[0].value === "All" &&
      !this.form.retailBasedDistrict
    )
      priceTypeVal = "normal";
    if (
      lowerCustomRate === "normal" &&
      this.form.originCities[0].value !== "All" &&
      !this.form.retailBasedDistrict
    )
      priceTypeVal = "normal_custom_3lc";
    if (
      lowerCustomRate === "normal" &&
      this.form.originCities[0].value === "All" &&
      this.form.retailBasedDistrict
    )
      priceTypeVal = "normal_retail_district";
    if (
      lowerCustomRate === "normal" &&
      this.form.originCities[0].value !== "All" &&
      this.form.retailBasedDistrict
    )
      priceTypeVal = "normal_custom_3lc_retail_district";
    if (lowerCustomRate === "khusus" && !this.form.retailBasedDistrict)
      priceTypeVal = "custom_client";
    if (lowerCustomRate === "khusus" && this.form.retailBasedDistrict)
      priceTypeVal = "custom_client_retail_district";
    if (
      lowerCustomRate === "kombinasi" &&
      this.form.originCities[0].value === "All" &&
      !this.form.retailBasedDistrict
    )
      priceTypeVal = "combination";
    if (
      lowerCustomRate === "kombinasi" &&
      this.form.originCities[0].value !== "All" &&
      !this.form.retailBasedDistrict
    )
      priceTypeVal = "combination_custom_3lc";
    if (
      lowerCustomRate === "kombinasi" &&
      this.form.originCities[0].value === "All" &&
      this.form.retailBasedDistrict
    )
      priceTypeVal = "combination_retail_district";
    if (
      lowerCustomRate === "kombinasi" &&
      this.form.originCities[0].value !== "All" &&
      this.form.retailBasedDistrict
    )
      priceTypeVal = "combination_custom_3lc_retail_district";
    return priceTypeVal;
  }
  get priceRateRetailStartDate() {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() + 1);
    return startDate;
  }

  async addRenewRateV2() {
    MainAppController.setSnackbarPositivity(true);
    MainAppController.setSnackbar(false);

    const formatDate = (date: any): string => {
      if (!date) return ""
      return this.isDateTimeEnabled
        ? moment(date).utcOffset(7).format("YYYY-MM-DDTHH:mm:ssZ")
        : formatDateNormal(date, "YYYY-MM-DD")
    }

    const payload = new AddRenewRatesClientManagementApiRequestV2({
      clientId: Number(this.id),
      versionBasic: this.detailClient.clientCurrentRate.clientVersionBaseRate,
      isCustomRate: this.isMixRateBool,
      startDate: formatDate(
        this.form.isCustomRate === "retail"
          ? this.priceRateRetailStartDate
          : this.form.priceRateStartDate
      ),
      endDate: formatDate(
        this.form.isCustomRate === "retail"
          ? this.detailClient.clientBilling.endDate
          : this.form.priceRateEndDate
      ),
      rateActiveDate: formatDate(this.isEdit ? this.form.priceRateExpired : ""),
      isLiveRate: true,
      discount:  this.detailClient?.clientCurrentRate?.clientDiscountBaseRate,
      discountProductTypes: this.form.discount
        .filter((d: any) => d.product?.name !== "SEMUA")
        .map((d: any) => ({
          // eslint-disable-next-line @typescript-eslint/camelcase
          product_type: d.product?.name || "",
          discount: Number(d.discount)
        })),
      versionName:
        typeof this.form.versionName === "object"
          ? this.form.versionName.rateVersionName
          : this.form.versionName,
      archiveFile:
        typeof this.form.archiveFile === "object" ? this.form.archiveFile : "",
      isCustomRateOnly: this.isCustomRateBool,
      priceType: this.priceType,
      insuranceType: this.form.isInsurance
        ? this.form.insurance === "custom-rates" ||
          this.form.insurance === "custom"
          ? "custom"
          : "bundling"
        : "",
      insurancePercentage: this.insurancePercentage,
      "3lcOrigin":
        this.form.originCities[0]?.value === "All"
          ? ""
          : this.form.originCities.map((oc: any) => oc.name).join(", "),
      useClientDiscountConfig: this.form.useClientDiscountConfig
    });
    const resp = await ClientManagementController.addRenewRatesV2(payload);
    if (resp) {
      ClientManagementController.getDetailV2(Number(this.id));
      this.onShowHidePopup();
      this.$router.push(`/client/client-management/${this.id}`).then(() => {
        MainAppController.setSnackbarMessage(
          this.$t("clientManagement.ratePopup.addPriceSuccess", { clientName: this.clientName }).toString()
        );
        MainAppController.setSnackbarTimeout(4000);
        MainAppController.setSnackbar(true);
      });
    }
  }

  get isBasicRateBool() {
    return this.form.isCustomRate === "normal";
  }
  get isMixRateBool() {
    return this.form.isCustomRate === "kombinasi";
  }
  get isCustomRateBool() {
    return this.form.isCustomRate === "khusus";
  }

  get handleRetail() {
    return (
      !this.form.isInsurance ||
      (this.form.isInsurance && this.form.insurance && !this.error.customRates)
    );
  }

  get handleNormal() {
    return (
      (this.form.versionBasic &&
        this.form.originCities.length &&
        this.useDiscountValidation &&
        !this.form.isInsurance) ||
      (this.form.versionBasic &&
        this.form.originCities.length &&
        this.useDiscountValidation &&
        this.form.isInsurance &&
        this.form.insurance &&
        !this.error.customRates)
    );
  }

  get handleKhusus() {
    return (
      (this.form.versionName &&
        this.form.archiveFile.name &&
        !this.form.isInsurance) ||
      (this.form.versionName &&
        this.form.archiveFile.name &&
        this.form.isInsurance &&
        this.form.insurance &&
        !this.error.customRates)
    );
  }

  get handleKombinasi() {
    return (
      (this.form.versionName &&
        this.form.versionBasic &&
        this.form.originCities.length &&
        this.useDiscountValidation &&
        this.form.archiveFile.name &&
        !this.form.isInsurance) ||
      (this.form.versionName &&
        this.form.versionBasic &&
        this.form.originCities.length &&
        this.useDiscountValidation &&
        this.form.archiveFile.name &&
        this.form.isInsurance &&
        this.form.insurance &&
        !this.error.customRates)
    );
  }

  get useDiscountValidation() {
    return this.form.useClientDiscountConfig
      ? this.form.discount && !this.error.discount
      : true;
  }

  get isValidRenewRate() {
    let result = false;
    if (this.form.isCustomRate === "retail") {
      if (this.handleRetail) result = true;
    }
    if (this.form.isCustomRate === "normal") {
      if (this.handleNormal) result = true;
    }
    if (this.form.isCustomRate === "khusus") {
      if (this.handleKhusus) result = true;
    }
    if (this.form.isCustomRate === "kombinasi") {
      if (this.handleKombinasi) result = true;
    }
    return (
      result && !this.error.priceRateStartDate && !this.error.priceRateEndDate
    );
  }

  onConfirmRenewal() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title: this.$t("clientManagement.infoPriceClient.changeParentClientPriceQuestion").toString(),
        message: this.$t("clientManagement.infoPriceClient.changeParentClientPriceMessage").toString(),
        image: "badge-confirmation-general",
        textSuccess: this.$t("clientManagement.infoPriceClient.yesChange").toString(),
        textCancel: this.$t("clientManagement.infoPriceClient.back").toString(),
        onClose: () => {
          MainAppController.closeMessageModal();
        },
        onSubmit: () => {
          MainAppController.closeMessageModal();
          this.addRenewRateV2();
        }
      })
    );
  }
  get tomorrow() {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    date.setHours(0, 0, 0, 0);
    date.setHours(date.getHours() + 1);
    return date;
  }

  get today() {
    const date = new Date();
    date.setHours(date.getHours() + 1);
    return date;
  }
}
export default PopupRenewRate;
